export const ROLES = {
  USER_ROLE: 'User',
  ADMINUSER_ROLE: 'Admin',
  SUPER_ADMIN_ROLE: 'Super Admin',
};

export default ROLES;
